// src/components/document/DocumentParagraph.tsx
import React from 'react';

interface DocumentParagraphProps {
  text: string;
}

const DocumentParagraph: React.FC<DocumentParagraphProps> = ({ text }) => {
  // Simple regex to replace **text** with <strong>text</strong>
  const processedText = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

  return (
    <p
      className="text-slate-700 leading-relaxed"
      dangerouslySetInnerHTML={{ __html: processedText }}
    />
  );
};

export default DocumentParagraph;